<p>Thank you for verifying your email.</p><p>You may now close this window or continue with using the site.</p>